import {GUARANTEE_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapGuaranteeToDomainValue = (guarantee?: string): DomainValueReference | null => {
  if (!guarantee || !(guarantee in GUARANTEE_TO_DV_MAPPING)) return null;

  return {$ref: GUARANTEE_TO_DV_MAPPING[guarantee as keyof typeof GUARANTEE_TO_DV_MAPPING]};
};
